export class TickEventManager {
  private frameEvents: Set<TickEvent>;
  private timeEvents: Set<TimeBasedTickEvent>;

  constructor() {
    this.frameEvents = new Set<TickEvent>();
    this.timeEvents = new Set<TimeBasedTickEvent>();
  }

  public tick() {
    this.frameEvents.forEach((e) => {
      if (e.canceled) {
        this.frameEvents.delete(e);
      } else {
        e.trigger();
      }
    });

    let execTime = new Date().getTime();
    this.timeEvents.forEach((e) => {
      if (e.canceled) {
        this.timeEvents.delete(e);
      } else if (e.lastExecutionTime + e.delay <= execTime) {
        e.trigger();
        e.lastExecutionTime = execTime;
      }
    });
  }

  public registerFrameEvent(callback: Function): TickEvent {
    let tickEvent = new TickEvent(callback, this);
    this.frameEvents.add(tickEvent);
    return tickEvent;
  }

  public registerTimeEvent(callback: Function, delay: number) {
    let tickEvent = new TimeBasedTickEvent(callback, this, delay);
    this.timeEvents.add(tickEvent);
    return tickEvent;
  }
}

export class TickEvent {
  protected _canceled: boolean;
  protected callback: Function;
  protected manager: TickEventManager;

  public get canceled() {
    return this._canceled;
  }

  constructor(callback: Function, tickManager: TickEventManager) {
    this.callback = callback;
    this.manager = tickManager;
    this._canceled = false;
  }

  public cancel() {
    this._canceled = true;
  }

  public trigger() {
    this.callback();
  }
}

export class TimeBasedTickEvent extends TickEvent {
  public lastExecutionTime: number;
  public delay: number;

  constructor(callback: Function, tickManager: TickEventManager, delay: number) {
    super(callback, tickManager);
    this.delay = delay;
    this.lastExecutionTime = 0;
  }
}
